export default __webpack_public_path__ + "31de24a960521abe3c9f4ff75aa761a6.png";